module.exports = __webpack_public_path__ + "files/c754e6625d151b1ab4b86415ee61af3a.png";